// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SimpleRoulete_mainCotainerRoulete__Y7bYK{
    display: flex;
    flex-direction: column;

    color:whitesmoke;
    
    min-height: 100vh;
}
.SimpleRoulete_containerBets__9\\+NTK{
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin:1rem 2rem 0 2rem;
}

body{
    color: #0f1721;
}
@keyframes SimpleRoulete_ApperAnimate__mKmhL {
    0% {
        opacity: 0;

    }
    100% {
        opacity: 1;

    }
}
.SimpleRoulete_main__qkYch{
    margin-top: 4rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.SimpleRoulete_mainGame__GqJ5y{

    z-index: 1000;     /* establish flex container */

    display: flex;
    flex-direction: row;            /* default value; can be omitted */
    flex-wrap: nowrap;              /* default value; can be omitted */

}
.SimpleRoulete_containerInfGame__ex6kP{
    display: flex;
    flex-direction: column;
    width: 30%;
    align-items: center;
    justify-content: center;
    order: 0;

}
.SimpleRoulete_textContainer__lYKva {
    font-size: 30px;
    color: whitesmoke;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
    user-select: none;
    /*margin-top: 20px; !* Регулируйте, чтобы создать желаемый отступ между текстом и таймером *!*/
}
.SimpleRoulete_containerNamingsGame__MAFqk{
    /*margin:10px;
    margin-left: 20px;
    margin-bottom: 10px;*/
    text-align: center;
    font-family: Poppins, sans-serif;
}

.SimpleRoulete_containerBetInGame__173sL{
    display: flex;
    flex-direction: row;
    order: 2;
    justify-content: space-between;
    align-items: center;
    flex-basis: calc(25% - 0.5rem);
    height: 60px;
    gap: 1.5rem;
    background: linear-gradient(315deg, var(--bg-color-start) 50%, var(--bg-color-end) 100%);
    border-radius: 1rem;
    padding: 1rem;
    animation: SimpleRoulete_ApperAnimate__mKmhL 0.8s ease-in-out;
    animation-fill-mode: forwards;
    margin-bottom: 1rem;

}
.SimpleRoulete_AllAmount__laGzU{
    font-size: 25px;
    color: #1be513;
    font-family: Poppins, sans-serif;
    margin-right: 1rem;
}

.SimpleRoulete_animateAmount__pzgLv{
    animation: SimpleRoulete_expandAnimation__d59Me 1.5s ease forwards;

}
@keyframes SimpleRoulete_expandAnimation__d59Me {
    0% {
        opacity: 0;
        transform: scale(1); /* Начальный масштаб */

    }
    100% {
        opacity: 1;

        transform: scale(1.5); /* Конечный масштаб */

    }
}
.SimpleRoulete_headerBetName__cQ\\+jf{
    font-size: 20px;
    color: var(--font-color);
    font-family: Poppins, sans-serif;
    margin-left: 1rem;
}

.SimpleRoulete_wrapperContentGame__cw4xj{
    display: flex;
    flex-direction: row;
    background-color: #242c54;
    border-radius: 2rem;
    
    
    flex-flow: row-reverse;
}
.SimpleRoulete_cotainerWheel__7MI3g{
    position: relative;
    width: 100%;
    min-height: 400px;
}
.SimpleRoulete_upI__HsCbD{
    position: absolute;
    top:-5%;
    left: 52%;
    transform: translate(-50%, -50%);
    color: #96e5b6;
    font-size: 32px;
    rotate: -45deg;
}
.SimpleRoulete_blockInf__cfHlD{

    display: flex;
    height: 100%;

    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap:0.5rem;
}
.SimpleRoulete_blockInf__cfHlD h2{
    color: whitesmoke;
    font-family: "Gilroy", sans-serif;
    font-weight: 500;
    font-size: 1.4rem;
    line-height: 1.6rem;
    text-align: center;
}
.SimpleRoulete_timerI__JUE1v{
    font-size: 23px;
    color:#96e5b5;
}
.SimpleRoulete_containerTimer__TnJHd{
    display: flex;
    flex-direction: row;
    gap:1rem;
}
.SimpleRoulete_containerLast10__k\\+4Bl{
    display: flex;
    flex-direction: row;
    align-items: center;
    gap:4px;
}

.SimpleRoulete_blockLast10__SaO0X{
    width: 8px;
    height: 1rem;
    border-radius: 10px;

    background: linear-gradient(180deg, var(--bg-color-start) 0%, var(--bg-color-end) 100%);
}
.SimpleRoulete_blockLast10__SaO0X.SimpleRoulete_x_3__iG7kk{
    height: 1.5rem;
}
.SimpleRoulete_blockLast10__SaO0X.SimpleRoulete_x_5__K6DKu{
    height: 2rem;
}
.SimpleRoulete_containerInforamtionWheel__Z11wY{
    position: relative;
    top:0;
    left: 0;
    display: block;
    width: 200px;
    height: 300px;

}



.SimpleRoulete_wrapperSvg__nVvFY,.SimpleRoulete_containerInforamtionWheel__Z11wY{
    position: absolute; /* Абсолютное позиционирование */
    top: 50%; /* Положение по вертикали в середине блока */
    left: 50%; /* Положение по горизонтали в середине блока */
    transform: translate(-50%, -50%); /* Центрируем по вертикали и горизонтали */
}

.SimpleRoulete_wrapper__REEvl{
    position: relative;
    margin: 0 auto;
}
.SimpleRoulete_containerTable__uGGRQ{

    display: flex;
    order: 1;
    flex-direction: column;
    max-width: 500px;
    justify-content: left;

    gap: 1rem;
    border-right: 1px solid #ffffff30; /* Добавляем красную линию справа */
    padding: 3rem 3rem;
}
.SimpleRoulete_no_bets__rWWnq{
    display: flex;
    margin-right: 30px;

    justify-content: center;
    align-items: center;
    order: 3;
    font-size: 30px;
    color: white;
    font-family: Gilroy, sans-serif;
    font-weight: 700;
}
.SimpleRoulete_containerBetsInf__\\+El-C{
    margin-top: 30px;
    margin-right: 20px;
    margin-bottom: 20px;
    display: flex;
    order: 2;
    flex-direction: column;
    gap: 1em;
}
.SimpleRoulete_containerBet__KYIVN{

    display: flex;
    flex-direction: row;
    order: 2;
    width: 100%;
    justify-content: left;
    align-items: center;
    height: 50px;
    gap: 1.5rem;
    background-color: #242c54;
    border-radius: 3rem;
    padding: 1rem;
    animation: SimpleRoulete_ApperAnimate__mKmhL 0.5s ease-in-out;
    animation-fill-mode: forwards;

}
.SimpleRoulete_betsAmountInf__PVfpm{
    color: greenyellow;
    font-size: 20px;
    font-family: Gilroy, sans-serif;
    font-weight: 600;
}
.SimpleRoulete_btnCancel__\\+SjT1{
    background-color: red;
}
.SimpleRoulete_choice_container__JxJxX{
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.SimpleRoulete_imgContainer__ryq8Q{
    margin-top: 1rem;

    display: flex;


    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
    user-select: none;
}
.SimpleRoulete_imgContainer__ryq8Q img{
    width: 100%;
    height: auto; /* Сохраняем пропорции изображения */
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
    user-select: none;
    pointer-events: none; /* Отключение взаимодействия с изображением */

}
.SimpleRoulete_img__ZgYYn
.SimpleRoulete_selected__gCryd {
    opacity: 1;
}


.SimpleRoulete_bet_container__DW3xK{

    display: flex;
    justify-content: center;
    flex-direction: column;

    /*width: 300px;*/
}
.SimpleRoulete_select-color__color_x2__XWA8I {
    --font-color: #94B2FF;
    --bg-color-start: rgba(90, 96, 228, .224);
    --bg-color-end: rgba(88, 103, 236, .64);
    --border-color: rgba(139, 157, 254, .18);

}
.SimpleRoulete_select-color__color_x50__89Ik7 {
    --font-color: #A4FDC7;
    --bg-color-start: rgba(43, 172, 71, .224);
    --bg-color-end: rgba(74, 202, 110, .64);
    --border-color: rgba(139, 254, 185, .18);

}
.SimpleRoulete_select-color__color_x3__IKF0V {
    --font-color: #ef294e;
    --bg-color-start: rgb(208 74 74 / 12%);
    --bg-color-end: rgb(255 11 11 / 34%);
    --border-color: rgba(184, 151, 255, .18);
}
.SimpleRoulete_select-color__color_x5__-MgzH {
    --font-color: #FFEDC8;
    --bg-color-start: rgba(216, 164, 87, .224);
    --bg-color-end: rgba(218, 197, 87, .64);
    --border-color: rgba(254, 208, 139, .18);
}
.SimpleRoulete_opac__qtXMG{
    opacity: 0.1;
}
@keyframes SimpleRoulete_pulse__k9vJy {
    0% {
        font-size: 20px;
    }
    50% {
        font-size: 30px;
    }
    100% {
        font-size: 20px;
    }
}
.SimpleRoulete_text_block__ak8LO{
    z-index: 1000;
    width: 100%;
    display: flex;

    margin-top: 30px;
    justify-content: center;
    font-family: "Gilroy" , sans-serif;
    font-weight: 600;
    color: #053fc7;
    animation: SimpleRoulete_pulse__k9vJy 2s infinite alternate;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
    user-select: none;
}
.SimpleRoulete_blockButtonCancel__CibBw{
    font-size: 28px;
    color: red;
    cursor: pointer;
    margin-left: auto; /* Это свойство поместит блок .blockButtonCancel в конец контейнера */


}
.SimpleRoulete_btnCancel__\\+SjT1 {
    width: 50px;
    height: 50px;
    box-shadow: 0px 10 10px 10px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    background: red;
    cursor: pointer;

    position: absolute;
    display: block;
    z-index: 200;
    text-indent: -9999px;
}

.SimpleRoulete_btnCancel__\\+SjT1:before,
.SimpleRoulete_btnCancel__\\+SjT1:after {
    content: '';
    width: 55%;
    height: 2px;
    background: #fff;
    position: absolute;
    top: 48%;
    left: 22%;
    transform: rotate(-45deg);
    transition: all 0.3s ease-out;
}

.SimpleRoulete_btnCancel__\\+SjT1:after {
    transform: rotate(45deg);
    transition: all 0.3s ease-out;
}

.SimpleRoulete_btnCancel__\\+SjT1:hover:before,
.SimpleRoulete_btnCancel__\\+SjT1:hover:after {
    transform: rotate(180deg);
}
.SimpleRoulete_containerBtnBet__5HqeE{
    display: flex;
    justify-content: center;
    align-items: center;
}


/*.game_field{*/
/*    display: flex;*/
/*    justify-content: left;*/

/*    order: 1;*/
/*    width: 1000px;*/
/*    height: 1000px;*/
/*    !*border: 1px green solid;*!*/
/*}*/
/*.UI{*/
/*    display: flex;*/
/*    justify-content: right;*/
/*    order: 2;*/
/*    width: 500px;*/
/*    height: 500px;*/
/*    !*border: 1px red solid;*!*/
/*}*/
@media (max-width: 880px) {
    .SimpleRoulete_wrapperContentGame__cw4xj{
        flex-direction: column;
    }
    .SimpleRoulete_containerTable__uGGRQ{
        max-width: 100%;
        border-right: 0;
        border-top: 1px solid #09675a; /* Добавляем красную линию справа */

    }







}
@media screen and (max-width: 799px){
    .SimpleRoulete_mainCotainerRoulete__Y7bYK{
        margin-left: 0;
    }
}
@media screen and (max-width: 1000px){

    .SimpleRoulete_containerTable__uGGRQ{
        width: 100%;
        padding: 1rem 0;
        justify-content: center;
        align-items: center;
    }
    .SimpleRoulete_wrapperContentGame__cw4xj{
        margin:0 2px 0 2px;

    }
    .SimpleRoulete_containerNamingsGame__MAFqk{
        margin-top:70px;
    }
    .SimpleRoulete_mainCotainerRoulete__Y7bYK{
        margin-left: 0;
    }
    .SimpleRoulete_containerBets__9\\+NTK{
        gap:2px;
        margin-bottom: 50px;

    }
    .SimpleRoulete_containerBetInGame__173sL{
        flex-basis: calc(100% - 0.5rem);
    }
    .SimpleRoulete_containerBetInGameSuccses__MKbGW{
        flex-basis: calc(100% - 0.5rem);
    }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Wheel/SimpleRoulete.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;;IAEtB,gBAAgB;;IAEhB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;AACA;IACI;QACI,UAAU;;IAEd;IACA;QACI,UAAU;;IAEd;AACJ;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;;IAEI,aAAa,MAAM,6BAA6B;;IAEhD,aAAa;IACb,mBAAmB,aAAa,kCAAkC;IAClE,iBAAiB,eAAe,kCAAkC;;AAEtE;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;;AAEZ;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;IAClD,iBAAiB;IACjB,8FAA8F;AAClG;AACA;IACI;;yBAEqB;IACrB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,8BAA8B;IAC9B,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,WAAW;IACX,wFAAwF;IACxF,mBAAmB;IACnB,aAAa;IACb,6DAAwC;IACxC,6BAA6B;IAC7B,mBAAmB;;AAEvB;AACA;IACI,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,kEAA6C;;AAEjD;AACA;IACI;QACI,UAAU;QACV,mBAAmB,EAAE,sBAAsB;;IAE/C;IACA;QACI,UAAU;;QAEV,qBAAqB,EAAE,qBAAqB;;IAEhD;AACJ;AACA;IACI,eAAe;IACf,wBAAwB;IACxB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;;;IAGnB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,gCAAgC;IAChC,cAAc;IACd,eAAe;IACf,cAAc;AAClB;AACA;;IAEI,aAAa;IACb,YAAY;;IAEZ,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,iCAAiC;IACjC,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,OAAO;AACX;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;;IAEnB,uFAAuF;AAC3F;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,KAAK;IACL,OAAO;IACP,cAAc;IACd,YAAY;IACZ,aAAa;;AAEjB;;;;AAIA;IACI,kBAAkB,EAAE,gCAAgC;IACpD,QAAQ,EAAE,4CAA4C;IACtD,SAAS,EAAE,8CAA8C;IACzD,gCAAgC,EAAE,0CAA0C;AAChF;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;AACA;;IAEI,aAAa;IACb,QAAQ;IACR,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;;IAErB,SAAS;IACT,iCAAiC,EAAE,mCAAmC;IACtE,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,kBAAkB;;IAElB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,+BAA+B;IAC/B,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,QAAQ;IACR,sBAAsB;IACtB,QAAQ;AACZ;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,6DAAwC;IACxC,6BAA6B;;AAEjC;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;;IAEhB,aAAa;;;IAGb,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;IAClD,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY,EAAE,oCAAoC;IAClD,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;IAClD,iBAAiB;IACjB,oBAAoB,EAAE,6CAA6C;;AAEvE;AACA;;IAEI,UAAU;AACd;;;AAGA;;IAEI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;;IAEtB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,yCAAyC;IACzC,uCAAuC;IACvC,wCAAwC;;AAE5C;AACA;IACI,qBAAqB;IACrB,yCAAyC;IACzC,uCAAuC;IACvC,wCAAwC;;AAE5C;AACA;IACI,qBAAqB;IACrB,sCAAsC;IACtC,oCAAoC;IACpC,wCAAwC;AAC5C;AACA;IACI,qBAAqB;IACrB,0CAA0C;IAC1C,uCAAuC;IACvC,wCAAwC;AAC5C;AACA;IACI,YAAY;AAChB;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI,aAAa;IACb,WAAW;IACX,aAAa;;IAEb,gBAAgB;IAChB,uBAAuB;IACvB,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;IACd,2DAAsC;IACtC,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;IAClD,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,UAAU;IACV,eAAe;IACf,iBAAiB,EAAE,qEAAqE;;;AAG5F;AACA;IACI,WAAW;IACX,YAAY;IACZ,gDAAgD;IAChD,mBAAmB;IACnB,eAAe;IACf,eAAe;;IAEf,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,oBAAoB;AACxB;;AAEA;;IAEI,WAAW;IACX,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IAKT,yBAAyB;IAKzB,6BAA6B;AACjC;;AAEA;IAKI,wBAAwB;IAKxB,6BAA6B;AACjC;;AAEA;;IAMI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA,eAAe;AACf,qBAAqB;AACrB,6BAA6B;;AAE7B,gBAAgB;AAChB,qBAAqB;AACrB,sBAAsB;AACtB,mCAAmC;AACnC,IAAI;AACJ,OAAO;AACP,qBAAqB;AACrB,8BAA8B;AAC9B,gBAAgB;AAChB,oBAAoB;AACpB,qBAAqB;AACrB,iCAAiC;AACjC,IAAI;AACJ;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,eAAe;QACf,eAAe;QACf,6BAA6B,EAAE,mCAAmC;;IAEtE;;;;;;;;AAQJ;AACA;IACI;QACI,cAAc;IAClB;AACJ;AACA;;IAEI;QACI,WAAW;QACX,eAAe;QACf,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,kBAAkB;;IAEtB;IACA;QACI,eAAe;IACnB;IACA;QACI,cAAc;IAClB;IACA;QACI,OAAO;QACP,mBAAmB;;IAEvB;IACA;QACI,+BAA+B;IACnC;IACA;QACI,+BAA+B;IACnC;AACJ","sourcesContent":[".mainCotainerRoulete{\n    display: flex;\n    flex-direction: column;\n\n    color:whitesmoke;\n    \n    min-height: 100vh;\n}\n.containerBets{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n    margin:1rem 2rem 0 2rem;\n}\n\nbody{\n    color: #0f1721;\n}\n@keyframes ApperAnimate {\n    0% {\n        opacity: 0;\n\n    }\n    100% {\n        opacity: 1;\n\n    }\n}\n.main{\n    margin-top: 4rem;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n.mainGame{\n\n    z-index: 1000;     /* establish flex container */\n\n    display: flex;\n    flex-direction: row;            /* default value; can be omitted */\n    flex-wrap: nowrap;              /* default value; can be omitted */\n\n}\n.containerInfGame{\n    display: flex;\n    flex-direction: column;\n    width: 30%;\n    align-items: center;\n    justify-content: center;\n    order: 0;\n\n}\n.textContainer {\n    font-size: 30px;\n    color: whitesmoke;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Old versions of Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n    /*margin-top: 20px; !* Регулируйте, чтобы создать желаемый отступ между текстом и таймером *!*/\n}\n.containerNamingsGame{\n    /*margin:10px;\n    margin-left: 20px;\n    margin-bottom: 10px;*/\n    text-align: center;\n    font-family: Poppins, sans-serif;\n}\n\n.containerBetInGame{\n    display: flex;\n    flex-direction: row;\n    order: 2;\n    justify-content: space-between;\n    align-items: center;\n    flex-basis: calc(25% - 0.5rem);\n    height: 60px;\n    gap: 1.5rem;\n    background: linear-gradient(315deg, var(--bg-color-start) 50%, var(--bg-color-end) 100%);\n    border-radius: 1rem;\n    padding: 1rem;\n    animation: ApperAnimate 0.8s ease-in-out;\n    animation-fill-mode: forwards;\n    margin-bottom: 1rem;\n\n}\n.AllAmount{\n    font-size: 25px;\n    color: #1be513;\n    font-family: Poppins, sans-serif;\n    margin-right: 1rem;\n}\n\n.animateAmount{\n    animation: expandAnimation 1.5s ease forwards;\n\n}\n@keyframes expandAnimation {\n    0% {\n        opacity: 0;\n        transform: scale(1); /* Начальный масштаб */\n\n    }\n    100% {\n        opacity: 1;\n\n        transform: scale(1.5); /* Конечный масштаб */\n\n    }\n}\n.headerBetName{\n    font-size: 20px;\n    color: var(--font-color);\n    font-family: Poppins, sans-serif;\n    margin-left: 1rem;\n}\n\n.wrapperContentGame{\n    display: flex;\n    flex-direction: row;\n    background-color: #242c54;\n    border-radius: 2rem;\n    \n    \n    flex-flow: row-reverse;\n}\n.cotainerWheel{\n    position: relative;\n    width: 100%;\n    min-height: 400px;\n}\n.upI{\n    position: absolute;\n    top:-5%;\n    left: 52%;\n    transform: translate(-50%, -50%);\n    color: #96e5b6;\n    font-size: 32px;\n    rotate: -45deg;\n}\n.blockInf{\n\n    display: flex;\n    height: 100%;\n\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap:0.5rem;\n}\n.blockInf h2{\n    color: whitesmoke;\n    font-family: \"Gilroy\", sans-serif;\n    font-weight: 500;\n    font-size: 1.4rem;\n    line-height: 1.6rem;\n    text-align: center;\n}\n.timerI{\n    font-size: 23px;\n    color:#96e5b5;\n}\n.containerTimer{\n    display: flex;\n    flex-direction: row;\n    gap:1rem;\n}\n.containerLast10{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap:4px;\n}\n\n.blockLast10{\n    width: 8px;\n    height: 1rem;\n    border-radius: 10px;\n\n    background: linear-gradient(180deg, var(--bg-color-start) 0%, var(--bg-color-end) 100%);\n}\n.blockLast10.x_3{\n    height: 1.5rem;\n}\n.blockLast10.x_5{\n    height: 2rem;\n}\n.containerInforamtionWheel{\n    position: relative;\n    top:0;\n    left: 0;\n    display: block;\n    width: 200px;\n    height: 300px;\n\n}\n\n\n\n.wrapperSvg,.containerInforamtionWheel{\n    position: absolute; /* Абсолютное позиционирование */\n    top: 50%; /* Положение по вертикали в середине блока */\n    left: 50%; /* Положение по горизонтали в середине блока */\n    transform: translate(-50%, -50%); /* Центрируем по вертикали и горизонтали */\n}\n\n.wrapper{\n    position: relative;\n    margin: 0 auto;\n}\n.containerTable{\n\n    display: flex;\n    order: 1;\n    flex-direction: column;\n    max-width: 500px;\n    justify-content: left;\n\n    gap: 1rem;\n    border-right: 1px solid #ffffff30; /* Добавляем красную линию справа */\n    padding: 3rem 3rem;\n}\n.no_bets{\n    display: flex;\n    margin-right: 30px;\n\n    justify-content: center;\n    align-items: center;\n    order: 3;\n    font-size: 30px;\n    color: white;\n    font-family: Gilroy, sans-serif;\n    font-weight: 700;\n}\n.containerBetsInf{\n    margin-top: 30px;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    display: flex;\n    order: 2;\n    flex-direction: column;\n    gap: 1em;\n}\n.containerBet{\n\n    display: flex;\n    flex-direction: row;\n    order: 2;\n    width: 100%;\n    justify-content: left;\n    align-items: center;\n    height: 50px;\n    gap: 1.5rem;\n    background-color: #242c54;\n    border-radius: 3rem;\n    padding: 1rem;\n    animation: ApperAnimate 0.5s ease-in-out;\n    animation-fill-mode: forwards;\n\n}\n.betsAmountInf{\n    color: greenyellow;\n    font-size: 20px;\n    font-family: Gilroy, sans-serif;\n    font-weight: 600;\n}\n.btnCancel{\n    background-color: red;\n}\n.choice_container{\n    margin-top: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n.imgContainer{\n    margin-top: 1rem;\n\n    display: flex;\n\n\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Old versions of Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n}\n.imgContainer img{\n    width: 100%;\n    height: auto; /* Сохраняем пропорции изображения */\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Old versions of Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n    pointer-events: none; /* Отключение взаимодействия с изображением */\n\n}\n.img\n.selected {\n    opacity: 1;\n}\n\n\n.bet_container{\n\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n\n    /*width: 300px;*/\n}\n.select-color__color_x2 {\n    --font-color: #94B2FF;\n    --bg-color-start: rgba(90, 96, 228, .224);\n    --bg-color-end: rgba(88, 103, 236, .64);\n    --border-color: rgba(139, 157, 254, .18);\n\n}\n.select-color__color_x50 {\n    --font-color: #A4FDC7;\n    --bg-color-start: rgba(43, 172, 71, .224);\n    --bg-color-end: rgba(74, 202, 110, .64);\n    --border-color: rgba(139, 254, 185, .18);\n\n}\n.select-color__color_x3 {\n    --font-color: #ef294e;\n    --bg-color-start: rgb(208 74 74 / 12%);\n    --bg-color-end: rgb(255 11 11 / 34%);\n    --border-color: rgba(184, 151, 255, .18);\n}\n.select-color__color_x5 {\n    --font-color: #FFEDC8;\n    --bg-color-start: rgba(216, 164, 87, .224);\n    --bg-color-end: rgba(218, 197, 87, .64);\n    --border-color: rgba(254, 208, 139, .18);\n}\n.opac{\n    opacity: 0.1;\n}\n@keyframes pulse {\n    0% {\n        font-size: 20px;\n    }\n    50% {\n        font-size: 30px;\n    }\n    100% {\n        font-size: 20px;\n    }\n}\n.text_block{\n    z-index: 1000;\n    width: 100%;\n    display: flex;\n\n    margin-top: 30px;\n    justify-content: center;\n    font-family: \"Gilroy\" , sans-serif;\n    font-weight: 600;\n    color: #053fc7;\n    animation: pulse 2s infinite alternate;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Old versions of Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n}\n.blockButtonCancel{\n    font-size: 28px;\n    color: red;\n    cursor: pointer;\n    margin-left: auto; /* Это свойство поместит блок .blockButtonCancel в конец контейнера */\n\n\n}\n.btnCancel {\n    width: 50px;\n    height: 50px;\n    box-shadow: 0px 10 10px 10px rgba(0, 0, 0, 0.25);\n    border-radius: 10px;\n    background: red;\n    cursor: pointer;\n\n    position: absolute;\n    display: block;\n    z-index: 200;\n    text-indent: -9999px;\n}\n\n.btnCancel:before,\n.btnCancel:after {\n    content: '';\n    width: 55%;\n    height: 2px;\n    background: #fff;\n    position: absolute;\n    top: 48%;\n    left: 22%;\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -ms-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n    -webkit-transition: all 0.3s ease-out;\n    -moz-transition: all 0.3s ease-out;\n    -ms-transition: all 0.3s ease-out;\n    -o-transition: all 0.3s ease-out;\n    transition: all 0.3s ease-out;\n}\n\n.btnCancel:after {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n    -webkit-transition: all 0.3s ease-out;\n    -moz-transition: all 0.3s ease-out;\n    -ms-transition: all 0.3s ease-out;\n    -o-transition: all 0.3s ease-out;\n    transition: all 0.3s ease-out;\n}\n\n.btnCancel:hover:before,\n.btnCancel:hover:after {\n    -webkit-transform: rotate(180deg);\n    -moz-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    -o-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n.containerBtnBet{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n\n/*.game_field{*/\n/*    display: flex;*/\n/*    justify-content: left;*/\n\n/*    order: 1;*/\n/*    width: 1000px;*/\n/*    height: 1000px;*/\n/*    !*border: 1px green solid;*!*/\n/*}*/\n/*.UI{*/\n/*    display: flex;*/\n/*    justify-content: right;*/\n/*    order: 2;*/\n/*    width: 500px;*/\n/*    height: 500px;*/\n/*    !*border: 1px red solid;*!*/\n/*}*/\n@media (max-width: 880px) {\n    .wrapperContentGame{\n        flex-direction: column;\n    }\n    .containerTable{\n        max-width: 100%;\n        border-right: 0;\n        border-top: 1px solid #09675a; /* Добавляем красную линию справа */\n\n    }\n\n\n\n\n\n\n\n}\n@media screen and (max-width: 799px){\n    .mainCotainerRoulete{\n        margin-left: 0;\n    }\n}\n@media screen and (max-width: 1000px){\n\n    .containerTable{\n        width: 100%;\n        padding: 1rem 0;\n        justify-content: center;\n        align-items: center;\n    }\n    .wrapperContentGame{\n        margin:0 2px 0 2px;\n\n    }\n    .containerNamingsGame{\n        margin-top:70px;\n    }\n    .mainCotainerRoulete{\n        margin-left: 0;\n    }\n    .containerBets{\n        gap:2px;\n        margin-bottom: 50px;\n\n    }\n    .containerBetInGame{\n        flex-basis: calc(100% - 0.5rem);\n    }\n    .containerBetInGameSuccses{\n        flex-basis: calc(100% - 0.5rem);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainCotainerRoulete": `SimpleRoulete_mainCotainerRoulete__Y7bYK`,
	"containerBets": `SimpleRoulete_containerBets__9+NTK`,
	"main": `SimpleRoulete_main__qkYch`,
	"mainGame": `SimpleRoulete_mainGame__GqJ5y`,
	"containerInfGame": `SimpleRoulete_containerInfGame__ex6kP`,
	"textContainer": `SimpleRoulete_textContainer__lYKva`,
	"containerNamingsGame": `SimpleRoulete_containerNamingsGame__MAFqk`,
	"containerBetInGame": `SimpleRoulete_containerBetInGame__173sL`,
	"ApperAnimate": `SimpleRoulete_ApperAnimate__mKmhL`,
	"AllAmount": `SimpleRoulete_AllAmount__laGzU`,
	"animateAmount": `SimpleRoulete_animateAmount__pzgLv`,
	"expandAnimation": `SimpleRoulete_expandAnimation__d59Me`,
	"headerBetName": `SimpleRoulete_headerBetName__cQ+jf`,
	"wrapperContentGame": `SimpleRoulete_wrapperContentGame__cw4xj`,
	"cotainerWheel": `SimpleRoulete_cotainerWheel__7MI3g`,
	"upI": `SimpleRoulete_upI__HsCbD`,
	"blockInf": `SimpleRoulete_blockInf__cfHlD`,
	"timerI": `SimpleRoulete_timerI__JUE1v`,
	"containerTimer": `SimpleRoulete_containerTimer__TnJHd`,
	"containerLast10": `SimpleRoulete_containerLast10__k+4Bl`,
	"blockLast10": `SimpleRoulete_blockLast10__SaO0X`,
	"x_3": `SimpleRoulete_x_3__iG7kk`,
	"x_5": `SimpleRoulete_x_5__K6DKu`,
	"containerInforamtionWheel": `SimpleRoulete_containerInforamtionWheel__Z11wY`,
	"wrapperSvg": `SimpleRoulete_wrapperSvg__nVvFY`,
	"wrapper": `SimpleRoulete_wrapper__REEvl`,
	"containerTable": `SimpleRoulete_containerTable__uGGRQ`,
	"no_bets": `SimpleRoulete_no_bets__rWWnq`,
	"containerBetsInf": `SimpleRoulete_containerBetsInf__+El-C`,
	"containerBet": `SimpleRoulete_containerBet__KYIVN`,
	"betsAmountInf": `SimpleRoulete_betsAmountInf__PVfpm`,
	"btnCancel": `SimpleRoulete_btnCancel__+SjT1`,
	"choice_container": `SimpleRoulete_choice_container__JxJxX`,
	"imgContainer": `SimpleRoulete_imgContainer__ryq8Q`,
	"img": `SimpleRoulete_img__ZgYYn`,
	"selected": `SimpleRoulete_selected__gCryd`,
	"bet_container": `SimpleRoulete_bet_container__DW3xK`,
	"select-color__color_x2": `SimpleRoulete_select-color__color_x2__XWA8I`,
	"select-color__color_x50": `SimpleRoulete_select-color__color_x50__89Ik7`,
	"select-color__color_x3": `SimpleRoulete_select-color__color_x3__IKF0V`,
	"select-color__color_x5": `SimpleRoulete_select-color__color_x5__-MgzH`,
	"opac": `SimpleRoulete_opac__qtXMG`,
	"text_block": `SimpleRoulete_text_block__ak8LO`,
	"pulse": `SimpleRoulete_pulse__k9vJy`,
	"blockButtonCancel": `SimpleRoulete_blockButtonCancel__CibBw`,
	"containerBtnBet": `SimpleRoulete_containerBtnBet__5HqeE`,
	"containerBetInGameSuccses": `SimpleRoulete_containerBetInGameSuccses__MKbGW`
};
export default ___CSS_LOADER_EXPORT___;
